import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../context/ThemeContext";

const GamesHub: React.FC = () => {
  const navigate = useNavigate();
  const { themeColors } = useContext(ThemeContext);


  const tronStyles = `
    @keyframes avaTronGlowSweep {
      0% { transform: translateX(-40%) rotate(-12deg); opacity: 0; }
      35% { opacity: 0.55; }
      70% { opacity: 0.22; }
      100% { transform: translateX(140%) rotate(-12deg); opacity: 0; }
    }

    @keyframes avaTronGridDrift {
      0% { background-position: 0 0, 0 0; }
      100% { background-position: 0 140px, 140px 0; }
    }

    @keyframes avaTronPulse {
      0%, 100% { opacity: 0.18; filter: blur(0px); }
      50% { opacity: 0.75; filter: blur(0.4px); }
    }

    @keyframes avaNodePulse {
      0%, 100% { transform: scale(0.75); opacity: 0.35; }
      50% { transform: scale(1.18); opacity: 1; }
    }
  `;



  const games = [
    {
      name: "AVAAIO Checkers",
      icon: "⛀",
      desc: "Classic neon strategy battles.",
      path: "/games/checkers",
    },
    {
      name: "AVAAIO Chess",
      icon: "♛",
      desc: "Advanced tactical AI matches.",
      path: "/games/chess",
    },
  ];

  return (
    <div
      style={{
        position: "relative",
        overflow: "hidden",
        minHeight: "100vh",
        textAlign: "center",
        color: themeColors.text,
        padding: "5rem 1rem 7rem",
        fontFamily: "Orbitron, sans-serif",
        background: themeColors.bg,
      }}
    >
      <style>{tronStyles}</style>

      {/* === PREMIUM AVA TRON BACKGROUND === */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          background: `radial-gradient(circle at 50% 18%, ${themeColors.accent}30, transparent 26%), radial-gradient(circle at 15% 80%, ${themeColors.accent2}24, transparent 22%), radial-gradient(circle at 85% 72%, ${themeColors.avaAccent}20, transparent 24%)`,
        }}
      />

      <div
        style={{
          position: "absolute",
          left: "-10%",
          right: "-10%",
          bottom: "-18%",
          height: "58%",
          pointerEvents: "none",
          opacity: 0.42,
          transform: "perspective(620px) rotateX(62deg)",
          transformOrigin: "center bottom",
          backgroundImage: `
            linear-gradient(${themeColors.accent}38 1px, transparent 1px),
            linear-gradient(90deg, ${themeColors.accent2}30 1px, transparent 1px)
          `,
          backgroundSize: "54px 54px",
          animation: "avaTronGridDrift 10s linear infinite",
          boxShadow: themeColors.glow,
        }}
      />

      <div
        style={{
          position: "absolute",
          left: "7%",
          right: "7%",
          top: "47%",
          height: "1px",
          pointerEvents: "none",
          background: `linear-gradient(90deg, transparent, ${themeColors.accent}, ${themeColors.accent2}, transparent)`,
          boxShadow: themeColors.glow,
          opacity: 0.72,
        }}
      />

      {[...Array(7)].map((_, i) => (
        <div
          key={`trace-v-${i}`}
          style={{
            position: "absolute",
            left: `${14 + i * 12}%`,
            top: `${18 + (i % 3) * 8}%`,
            width: "2px",
            height: `${22 + (i % 2) * 18}%`,
            borderRadius: 999,
            pointerEvents: "none",
            background: `linear-gradient(to bottom, transparent, ${themeColors.accent}, transparent)`,
            boxShadow: themeColors.glow,
            opacity: 0.24,
            animation: `avaTronPulse ${2.4 + i * 0.35}s ease-in-out infinite`,
          }}
        />
      ))}

      {[...Array(6)].map((_, i) => (
        <div
          key={`trace-d-${i}`}
          style={{
            position: "absolute",
            left: `${8 + i * 16}%`,
            top: `${24 + i * 7}%`,
            width: "180px",
            height: "1px",
            pointerEvents: "none",
            transform: `rotate(${i % 2 === 0 ? 28 : -28}deg)`,
            background: `linear-gradient(90deg, transparent, ${themeColors.accent2}, transparent)`,
            boxShadow: themeColors.glow,
            opacity: 0.28,
          }}
        />
      ))}

      {[...Array(10)].map((_, i) => (
        <div
          key={`node-${i}`}
          style={{
            position: "absolute",
            left: `${10 + ((i * 17) % 80)}%`,
            top: `${18 + ((i * 23) % 62)}%`,
            width: 6,
            height: 6,
            borderRadius: "50%",
            pointerEvents: "none",
            background: themeColors.accent,
            boxShadow: themeColors.glow,
            animation: `avaNodePulse ${2.2 + (i % 4) * 0.4}s ease-in-out infinite`,
          }}
        />
      ))}

      <div
        style={{
          position: "absolute",
          top: "16%",
          left: "-22%",
          width: "55%",
          height: "18%",
          pointerEvents: "none",
          background: `linear-gradient(90deg, transparent, ${themeColors.accent}28, transparent)`,
          filter: "blur(14px)",
          animation: "avaTronGlowSweep 7s ease-in-out infinite",
        }}
      />

      <div style={{ position: "relative", zIndex: 2 }}>
      <h1 style={{ color: themeColors.accent, marginBottom: 12 }}>🎮 AVAAIO Games Hub</h1>
      <p style={{ marginBottom: 34, opacity: 0.86 }}>Choose a game to begin:</p>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: "22px",
          width: "min(760px, 92vw)",
          margin: "0 auto 46px",
        }}
      >
        {games.map((g) => (
          <button
            key={g.name}
            className="console-btn"
            onClick={() => navigate(g.path)}
            style={{
              minHeight: 220,
              borderRadius: 30,
              padding: "24px 18px",
              background: `linear-gradient(160deg, ${themeColors.accent}20, ${themeColors.cardBg})`,
              border: `1px solid ${themeColors.accent}`,
              color: themeColors.text,
              boxShadow: `0 0 34px ${themeColors.accent}22`,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 14,
              width: "100%",
              cursor: "pointer",
              transition: "all 0.25s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px) scale(1.02)";
              e.currentTarget.style.boxShadow = `0 0 44px ${themeColors.accent}55`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0px) scale(1)";
              e.currentTarget.style.boxShadow = `0 0 34px ${themeColors.accent}22`;
            }}
          >
            <div
              style={{
                fontSize: 72,
                lineHeight: 1,
                textShadow: themeColors.glow,
                filter: `drop-shadow(0 0 16px ${themeColors.accent})`,
              }}
            >
              {g.icon}
            </div>

            <div
              style={{
                fontSize: 24,
                fontWeight: 800,
                letterSpacing: 1,
              }}
            >
              {g.name}
            </div>

            <div
              style={{
                fontSize: 13,
                opacity: 0.78,
                maxWidth: 220,
                lineHeight: 1.5,
              }}
            >
              {g.desc}
            </div>
          </button>
        ))}
      </div>
    
      {/* Floating Navigation Buttons */}
      


      </div>
</div>
  );
};

export default GamesHub;
